import { component } from 'picoapp';
import app from 'app';
import { clear } from 'utils/node';
import { setURLParams, applyFilter } from 'utils/filter';
import Placeholder from 'utils/placeholders';

export default component((node) => {
  const products = node.querySelector<HTMLElement>('[data-products]');
  const pagination = node.querySelector<HTMLElement>('[data-pagination]');
  const ctas = node.querySelector<HTMLElement>('[data-ctas]');

  const filterTrigger: HTMLButtonElement = node.querySelector('[data-trigger="filter"]');

  filterTrigger.addEventListener('click', () => {
    document.dispatchEvent(new Event('filter:toggle'));
  });

  const loading = (trigger?: HTMLAnchorElement) => {
    products.parentElement.classList.add('is-loading');
    if (trigger) trigger.textContent = theme.strings.states.loading;
  };

  const unloading = () => {
    products.parentElement.classList.remove('is-loading');
  };

  node.addEventListener('click', (e) => {
    const target = e.target as HTMLAnchorElement;

    if (target.hasAttribute('data-load-more')) {
      e.preventDefault();

      loading(target);
      applyFilter(new URL(target.href).search, false);

      // Remove page searchparam after load
      const params = new URLSearchParams(window.location.search);
      params.delete('page');

      const path = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
      window.history.pushState({}, '', path);
    }
  });

  const getHTML = async (query: string): Promise<string> => {
    const response = await fetch(`${window.location.pathname}?${query}`);
    const html = await response.text();

    return html;
  };

  const fetchProducts = async () => {
    const params = new URLSearchParams(window.location.search);
    params.set('section_id', node.id)

    const html = await getHTML(params.toString());

    const temp = document.createElement('div');
    temp.innerHTML = html;

    return {
      products: temp.querySelector('[data-products]').innerHTML,
      pagination: temp.querySelector('[data-pagination]').innerHTML,
      ctas: temp.querySelector('[data-ctas]').innerHTML,
    };
  };

  const renderProducts = async (
    response: { products: string, pagination: string, ctas: string },
    clean: boolean = false,
  ) => {
    if (clean) clear(products);
    products.insertAdjacentHTML('beforeend', response.products);

    clear(pagination);
    if (response.pagination) {
      pagination.insertAdjacentHTML('beforeend', response.pagination);
    }

    clear(ctas);
    if (response.ctas) {
      ctas.insertAdjacentHTML('beforeend', response.ctas);
    }

    document.dispatchEvent(new Event('filter:loaded'));
  };

  document.addEventListener('filter:change', async (event: CustomEvent) => {
    const placeholderCount = products.childElementCount ?? 3;
    const productPlaceholders = new Placeholder(['w-1/2', 'w-3/4', 'w-4/6'], placeholderCount);

    const { detail: { query, clean } } = event;
    loading();
    setURLParams(query);

    if (clean) {
      clear(products);
      products.insertAdjacentHTML('beforeend', productPlaceholders.html());
    }

    const response = await fetchProducts();
    await renderProducts(response, clean);
  });

  document.addEventListener('filter:loaded', () => {
    unloading();
    app.mount();
  });
});
